import { Nft } from '../types'
import { IPFS_GATEWAY } from '../babydogeswap'

export const doggies: Nft[] = [
  {
    name: 'Bulldogs',
    description: 'Unique digital NFT',
    images: {
      lg: 'bulldogs-lg.webp',
      md: 'bulldogs-md.webp',
      sm: 'bulldogs-sm.webp',
      ipfs: 'https://gateway.pinata.cloud/ipfs/QmXqR7Un7tKtmoTn3moS8dPtGJYuoLnC8kg2wNGXvAuPNa'
    },
    identifier: 'Bulldogs',
    id: 0
  },
  {
    name: 'Huskies',
    description: 'Unique digital NFT',
    images: {
      lg: 'huskies-lg.webp',
      md: 'huskies-md.webp',
      sm: 'huskies-sm.webp',
      ipfs: 'https://gateway.pinata.cloud/ipfs/QmYTgLi38i53FGU6yJvTLhhprVEe3bGHKM1GBz8o6KZhpH'
    },
    identifier: 'Huskies',
    id: 1
  },
  {
    name: 'Shepherds',
    description: 'Unique digital NFT',
    images: {
      lg: 'shepherds-lg.webp',
      md: 'shepherds-md.webp',
      sm: 'shepherds-sm.webp',
      ipfs: 'https://gateway.pinata.cloud/ipfs/QmVCbTdE4dAyoVnJa8SV9Xjok7hT5MGqvuCBm1YXMkCLBX'
    },
    identifier: 'Shepherds',
    id: 2
  },
  {
    name: 'Baller',
    description: 'Absolute (lottery) baller.',
    images: {
      lg: 'baller-lg.webp',
      md: 'baller-md.webp',
      sm: 'baller-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmeMfJk6yxYmMd41ThDpqcdEJmKXZTF9EmFeP49D15NvsF/baller.webp`
    },
    video: {
      webm: `${IPFS_GATEWAY}/QmeMfJk6yxYmMd41ThDpqcdEJmKXZTF9EmFeP49D15NvsF/baller.webm`,
      mp4: `${IPFS_GATEWAY}/QmeMfJk6yxYmMd41ThDpqcdEJmKXZTF9EmFeP49D15NvsF/baller.mp4`
    },
    identifier: 'baller',
    id: 20
  },
  {
    name: 'Lucky',
    description: "Lucky's got the golden ticket!",
    images: {
      lg: 'lucky-lg.webp',
      md: 'lucky-md.webp',
      sm: 'lucky-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmQzwfooRxLKigK7XBJzsQbP4DBpZW8jRM1sq5wrJLg6nF/lucky.webp`
    },
    video: {
      webm: `${IPFS_GATEWAY}/QmQzwfooRxLKigK7XBJzsQbP4DBpZW8jRM1sq5wrJLg6nF/lucky.webm`,
      mp4: `${IPFS_GATEWAY}/QmQzwfooRxLKigK7XBJzsQbP4DBpZW8jRM1sq5wrJLg6nF/lucky.mp4`
    },
    identifier: 'lucky',
    id: 19
  },
  {
    name: 'Lottie',
    description: "Lottie's looking hotto for lotto!",
    images: {
      lg: 'lottie-lg.webp',
      md: 'lottie-md.webp',
      sm: 'lottie-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmWnhyxSrD8v9bx5tE9mDkwW853bpjoCXGd7o2fe1BtQJ8/lottie.webp`
    },
    video: {
      webm: `${IPFS_GATEWAY}/QmWnhyxSrD8v9bx5tE9mDkwW853bpjoCXGd7o2fe1BtQJ8/lottie.webm`,
      mp4: `${IPFS_GATEWAY}/QmWnhyxSrD8v9bx5tE9mDkwW853bpjoCXGd7o2fe1BtQJ8/lottie.mp4`
    },
    identifier: 'lottie',
    id: 18
  },
  {
    name: 'Claire',
    description: "Can Claire the clairvoyant see what's in the cards for you?",
    images: {
      lg: 'claire-lg.webp',
      md: 'claire-md.webp',
      sm: 'claire-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmRa2WbGnqdgUzrYXxZWv549BDxq3heYridJeoWGcebcU8/claire.webp`
    },
    identifier: 'claire',
    id: 17
  },
  {
    name: 'Syrup Soak',
    description: 'Ahh... what could be sweeter than a syrupy soak?',
    images: {
      lg: 'soak-lg.webp',
      md: 'soak-md.webp',
      sm: 'soak-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmW3zLfdQpw9vWpgcDyR2WM9A34tTWvvYyjKc3JjhtL68z/syrup-soak.webp`
    },
    video: {
      webm: `${IPFS_GATEWAY}/QmW3zLfdQpw9vWpgcDyR2WM9A34tTWvvYyjKc3JjhtL68z/syrup-soak.webm`,
      mp4: `${IPFS_GATEWAY}/QmW3zLfdQpw9vWpgcDyR2WM9A34tTWvvYyjKc3JjhtL68z/syrup-soak.mp4`
    },
    identifier: 'syrup-soak',
    id: 16
  },
  {
    name: 'Easter ‘21 Champions',
    description: 'Eggscellent! Celebrating Syrup Storm winning the Easter Battle!',
    images: {
      lg: 'easter-champion-storm-lg.webp',
      md: 'easter-champion-storm-md.webp',
      sm: 'easter-champion-storm-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmWFQdggxnAkgFNBWixT6v7nrgEnYfYDxG5A9u42aHhU6U/easter-champion-storm.webp`
    },
    video: {
      webm: `${IPFS_GATEWAY}/QmWFQdggxnAkgFNBWixT6v7nrgEnYfYDxG5A9u42aHhU6U/easter-champion-storm.webm`,
      mp4: `${IPFS_GATEWAY}/QmWFQdggxnAkgFNBWixT6v7nrgEnYfYDxG5A9u42aHhU6U/easter-champion-storm.mp4`
    },
    identifier: 'easter-champion-storm',
    id: 15
  },
  {
    name: "Cakeston Easter '21",
    description: 'Melting Easter eggs and melting hearts!',
    images: {
      lg: 'cakeston-easter-21-lg.webp',
      md: 'cakeston-easter-21-md.webp',
      sm: 'cakeston-easter-21-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmZGqWaovULNEMKxBCGnGjh27JQkAyadS6AW4J4Lzf3XBp/easter-caker.webp`
    },
    identifier: 'easter-caker',
    id: 15
  },
  {
    name: "Flipsie Easter '21",
    description: "Watch out for Flipsie's spatula smash!",
    images: {
      lg: 'flipsie-easter-21-lg.webp',
      md: 'flipsie-easter-21-md.webp',
      sm: 'flipsie-easter-21-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmZGqWaovULNEMKxBCGnGjh27JQkAyadS6AW4J4Lzf3XBp/easter-flipper.webp`
    },
    identifier: 'easter-flipper',
    id: 14
  },
  {
    name: "Stormy Easter '21",
    description: 'Do you like chocolate with your syrup? Go long!',
    images: {
      lg: 'stormy-easter-21-lg.webp',
      md: 'stormy-easter-21-md.webp',
      sm: 'stormy-easter-21-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmZGqWaovULNEMKxBCGnGjh27JQkAyadS6AW4J4Lzf3XBp/easter-storm.webp`
    },
    identifier: 'easter-storm',
    id: 12
  },
  {
    name: 'Bullish',
    description: "Happy Niu Year! This bunny's excited for the year of the bull (market!)",
    images: {
      lg: 'bullish-lg.webp',
      md: 'bullish-md.webp',
      sm: 'bullish-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmNS1A5HsRW1JvFWtGkm4o9TgZVe2P7kA8TB4yxvS6A7ms/bullish.webp`
    },
    video: {
      webm: `${IPFS_GATEWAY}/QmNS1A5HsRW1JvFWtGkm4o9TgZVe2P7kA8TB4yxvS6A7ms/bullish.webm`,
      mp4: `${IPFS_GATEWAY}/QmNS1A5HsRW1JvFWtGkm4o9TgZVe2P7kA8TB4yxvS6A7ms/bullish.mp4`
    },
    identifier: 'bullish',
    id: 11
  },
  {
    name: 'Hiccup',
    description: "Oopsie daisy! Hiccup's had a bit of an accident. Poor little fella.",
    images: {
      lg: 'hiccup-lg.webp',
      md: 'hiccup-md.webp',
      sm: 'hiccup-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmQ6EE6gkVzAQUdQLLM7CyrnME6LZHCoy92ZERW8HXmyjw/hiccup.webp`
    },
    identifier: 'hiccup',
    id: 10
  },
  {
    name: 'Sleepy',
    description: 'Aww, looks like eating pancakes all day is tough work. Sweet dreams!',
    images: {
      lg: 'sleepy-lg.webp',
      md: 'sleepy-md.webp',
      sm: 'sleepy-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmYD9AtzyQPjSa9jfZcZq88gSaRssdhGmKqQifUDjGFfXm/sleepy.webp`,
      blur: 'sleepy-blur.webp'
    },
    identifier: 'sleepy',
    id: 5
  },
  {
    name: 'Sunny',
    description: 'Sunny is always cheerful when there are pancakes around. Smile!',
    images: {
      lg: 'sunny-lg.webp',
      md: 'sunny-md.webp',
      sm: 'sunny-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmYD9AtzyQPjSa9jfZcZq88gSaRssdhGmKqQifUDjGFfXm/sunny.webp`,
      blur: 'sunny-blur.webp'
    },
    identifier: 'sunny',
    id: 9
  },
  {
    name: 'Churro',
    description: "Don't let that dopey smile deceive you... Churro's a master BabyDoge chef!",
    images: {
      lg: 'churro-lg.webp',
      md: 'churro-md.webp',
      sm: 'churro-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmYD9AtzyQPjSa9jfZcZq88gSaRssdhGmKqQifUDjGFfXm/churro.webp`,
      blur: 'churro-blur.webp'
    },
    identifier: 'churro',
    id: 8
  },
  {
    name: 'Dollop',
    description: "Nommm... Oh hi, I'm just meditating on the meaning of BabyDoge.",
    images: {
      lg: 'dollop-lg.webp',
      md: 'dollop-md.webp',
      sm: 'dollop-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmYD9AtzyQPjSa9jfZcZq88gSaRssdhGmKqQifUDjGFfXm/dollop.webp`,
      blur: 'dollop-blur.webp'
    },
    identifier: 'dollop',
    id: 6
  },
  {
    name: 'Twinkle',
    description: "Three guesses what's put that twinkle in those eyes! (Hint: it's BabyDoge)",
    images: {
      lg: 'twinkle-lg.webp',
      md: 'twinkle-md.webp',
      sm: 'twinkle-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmYD9AtzyQPjSa9jfZcZq88gSaRssdhGmKqQifUDjGFfXm/twinkle.webp`,
      blur: 'twinkle-blur.webp'
    },
    identifier: 'twinkle',
    id: 7
  },
  {
    name: 'Drizzle',
    description: "It's raining syrup on this bunny, but he doesn't seem to mind. Can you blame him?",
    images: {
      lg: 'drizzle-lg.webp',
      md: 'drizzle-md.webp',
      sm: 'drizzle-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmXdHqg3nywpNJWDevJQPtkz93vpfoHcZWQovFz2nmtPf5/drizzle.webp`,
      blur: 'drizzle-blur.webp'
    },
    identifier: 'drizzle',
    id: 1
  },
  {
    name: 'Circular',
    description: "Love makes the world go 'round... but so do pancakes. And these bunnies know it.",
    images: {
      lg: 'circular-lg.webp',
      md: 'circular-md.webp',
      sm: 'circular-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmXdHqg3nywpNJWDevJQPtkz93vpfoHcZWQovFz2nmtPf5/circular.webp`,
      blur: 'circular-blur.webp'
    },
    identifier: 'circular',
    id: 3
  },
  {
    name: 'Sparkle',
    description: "It's sparkling syrup, pancakes, and even lottery tickets! This bunny really loves it.",
    images: {
      lg: 'sparkle-lg.webp',
      md: 'sparkle-md.webp',
      sm: 'sparkle-sm.webp',
      ipfs: `${IPFS_GATEWAY}/QmXdHqg3nywpNJWDevJQPtkz93vpfoHcZWQovFz2nmtPf5/sparkle.webp`,
      blur: 'sparkle-blur.webp'
    },
    identifier: 'sparkle',
    id: 4
  }
]
